import styled from "styled-components"

export const StyledTextFieldFormItem = styled.div`
  --label-width: 70px;
  display: flex;
  position: relative;
  width: 100%;

  --input-padding: 16px;
`
export const StyledLabel = styled.label`
  position: absolute;
  text-align: left;
  left: var(--input-padding);
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  line-height: 160%;
  color: #1C1C1E;
  z-index: 10;
  pointer-events: none;
`

export const StyledInput = styled.input<{
  $disabled?: boolean
}>`
  background: var(--white-white-5, rgba(255, 255, 255, 0.049));
  border-radius: 8px;
  backdrop-filter: blur(60px);
  padding: 17.25px 16px;
  padding-left: var(--label-width);
  line-height: 26px;
  font-weight: 400;
  border-radius: 8px;

  border: 1px solid rgba(0, 38, 58, 0.32);

  color: var(--Data_Dinner, #14C9C9);

  text-align: right;
  width: 100%;
  height: 100%;
  font-size: 16px;

  &:focus,
  &:active,
  &:focus-visible {
    outline: none;
    border: 1px solid var(--Schemes-Primary, #0da3ba);
  }

  &::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: #1C1C1E;
    font-size: 16px;
    font-weight: 400;
    opacity: 0.5;
  }

  &::-moz-placeholder {
    /* Firefox 19+ */
    color: #1C1C1E;
    font-size: 16px;
    font-weight: 400;
    opacity: 0.5;
  }
`
